import { GuidService } from 'ui-components/services/guid-service';

/**
 * @typedef {import('../split-ship-api-types.d.ts').AdjustItemsRequestItem} AdjustItemsRequestItem
 */

/**
 * Creates an item request object for the split ship request
 * @param {string} originFulfillmentPlanId
 * @param {string} fulfillmentPlanItemId
 * @param {number} quantity
 * @param {boolean} [shouldPreserveItemWithZeroQuantity]
 * @returns {AdjustItemsRequestItem}
 */
export const createAdjustItemsRequestItem = (
  originFulfillmentPlanId,
  fulfillmentPlanItemId,
  quantity,
  shouldPreserveItemWithZeroQuantity = false,
) => {
  const item = {
    originFulfillmentPlanItem: {
      fulfillmentPlanId: originFulfillmentPlanId,
      fulfillmentPlanItemId,
    },
    quantity,
    requestId: GuidService.newGuid(),
  };

  if (quantity === 0 && shouldPreserveItemWithZeroQuantity) {
    item.shouldPreserveItemWithZeroQuantity = true;
  }

  return item;
};
